export enum ReportsInventoryRoutes {
    accountsReceivable = "accounts-receivable",
    inventoryValuationSummary = "inventory-valuation-summary",
    inventoryValuationDetail = "inventory-valuation-details",
    inventorySnapshot = "inventory-snapshot",
    profitability = "profitability",
    inventoryopeninvoice = "open-invoices",
    inventoryallinvoice = "all-invoices",
    invoiceByRep = "invoices-by-reps",
    invoiceByCustomer = "invoice-by-cutomer",
    profitByRep = "profit-by-rep",
    profitByCustomer = "profit-by-cutomer",
    shipping = "shipping",
    openSalesOrders = "open-sales-orders",
    backSalesOrders = "sales-back-order",
    salesOrderCommited = "sales-order-commited",
    picktimebypicker = "average-pick-time-by-picker",
    picktimebylocation = "average-pick-time-by-location",
    packtimebypacker = "average-pack-time-by-packer",
    packtimebylocation = "average-pack-time-by-location",
    accountsPayable = "accounts-payable",
    incomeCutomerDetail = "income-by-customer-details",
    incomeCutomerSummary = "income-by-customer-summary",
    expensesVendorDetail = "expenses-by-vendor-detail",
    expensesVendorSummary = "expenses-by-vendor-summary",
    inventoryAging = "inventory-aging",
    openPurchaseOrder = "open-purchase-order",
    transactionByVendor = "transaction-by-vendor",
}
export const ReportsInventoryNames = {
    accountsReceivable: "accountsReceivable",
    inventoryopeninvoice: "inventoryopeninvoice",
    inventoryallinvoice: "inventoryallinvoice",
    invoiceByRep: "invoicesByReps",
    invoiceByCustomer: "inventoryinvoicesbycustomer",
    profitByRep: "profitByRep",
    profitByCustomer: "profitByCustomer",
    openSalesOrders: "openSalesOrders",
    accountsPayable: "accountsPayable",
    profitability: "profitability",
    inventoryValuationSummary: "inventoryValuationSummary",
    inventoryValuationDetail: "inventoryValuationDetail",
    inventorySnapshot: "inventorySnapshot",
    shipping: "shipping",
    picktimebypicker: "picktimebypicker",
    picktimebylocation: "picktimebylocation",
    packtimebypacker: "packtimebypacker",
    packtimebylocation: "packtimebylocation",
    backSalesOrders: "backSalesOrders",
    salesOrderCommited: "salesOrderCommited",
    inventoryAging: "inventoryAging",
    openPurchaseOrder: "openPurchaseOrder",
    transactionByVendor: "transactionByVendor",
} as const;

export const ReportsInventoryLabelName = {
    accountsReceivable: "Accounts Receivable",
    inventoryopeninvoice: "Open Invoices Report",
    inventoryallinvoice: "All Invoices Report",
    invoiceByRep: "Invoices by Reps",
    invoiceByCustomer: "Invoices by Customer",
    profitByRep: "Profit by Reps",
    profitByCustomer: "Profit by Customer",
    openSalesOrders: "Open Sales Orders Report",
    accountsPayable: "Accounts Payable Report",
    profitability: "Inventory Profitability Report",
    inventoryValuationSummary: "Inventory Valuation Summary",
    inventoryValuationDetail: "Inventory Valuation Detail",
    inventorySnapshot: "Current Inventory Snapshot",
    shipping: "Shipping Report",
    picktimebypicker: "Avg Pick-time By Picker",
    picktimebylocation: "Avg Pick-time By Location",
    packtimebypacker: "Avg Pack-time By Packer",
    packtimebylocation: "Avg Pack-time By Location",
    backSalesOrders: "Sales Back Order Report",
    salesOrderCommited: "Sales Order Committed Report",
    inventoryAging: "inventoryAging",
    openPurchaseOrder: "Open Purchase Order",
    transactionByVendor: "Transaction List by Vendor",
} as const;

//API Methods
export const ReportsInventoryAPIMethods = {
    InventoryInvoice: "InventoryInvoice",
    InventoryCustomers: "InventoryCustomers",
    InventoryCustomersGrouped: "GetInventoryCustomersGroupedPagedList",
    InventorySalesOrder: "InventorySalesOrder",
    InventoryVendor: "InventoryVendor",
    InventoryVendorGrouped: "GetInventoryVendorGroupedPagedList",
    Inventory: "Inventory",
    AccountsReceivableDetail: "AccountsReceivableDetail",
    AccountsPayableDetail: "AccountsPayableDetail",
    Shipping: "Shipping",
    InventoryAvgPickPackDetail: "InventoryAvgPickPackDetail",
    inventoryAging: "inventory-aging",
    openPurchaseOrder: "open-purchase-order",
    transactionByVendor: "transaction-by-vendor",
} as const;
